/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { get, computed, action } from '@ember/object';
import { isNone, isEmpty } from '@ember/utils';
import { Task } from 'ember-concurrency';
import SegmentModel from 'cio/models/segment';
import { tracked } from '@glimmer/tracking';
import AuthService from 'cio/services/auth';

interface BulkActionsArgs {
  archived: boolean;
  selected: SegmentModel[];
  deleteTask: Task<unknown, []>;
  archiveTask: Task<unknown, [boolean]>;
  canConfirmConsent: boolean;
  confirmConsentTask: Task<unknown, []>;
}

export default class BulkActions extends Component<BulkActionsArgs> {
  @service auth!: AuthService;

  @tracked confirmationModalText = '';
  @tracked googleAdwordsConsent = false;
  @tracked showDigitalComplianceModal = false;

  @action
  confirmConsent() {
    this.args.confirmConsentTask.perform();
    this.showDigitalComplianceModal = false;
  }
  get canDeleteSelectedSegments() {
    if (isNone(this.args.selected) || isEmpty(this.args.selected)) {
      return false;
    }

    return String(this.args.selected.length) === this.confirmationModalText;
  }

  @computed('args.selected.@each.audiences')
  get segmentsWithAudiences() {
    return this.args.selected.filter((segment) => get(segment, 'audiences')?.length);
  }

  get disabledDeleteTooltipContent() {
    if (this.args.selected.some((s) => !s.canBeDeleted)) {
      if (this.args.selected.some((s) => s.isLinkedToAnyNonDeletedForm)) {
        return 'Some of your selected segments are linked to a form and cannot be deleted.';
      }
      return 'Some of your selected segments are in use and cannot be deleted.';
    }

    return;
  }

  get disabledArchiveTooltipContent() {
    if (!this.args.archived && this.args.selected.some((s) => !s.canBeArchived)) {
      if (this.args.selected.some((s) => s.isLinkedToConnectedForm)) {
        return 'Some of your selected segments are linked to a connected form and cannot be archived.';
      }
      return 'Some of your selected segments are in use and cannot be archived.';
    }

    return;
  }
}
